<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      center
      :modal="false"
      :show-close="false"
      :destroy-on-close="true"
      :before-close="$onClose"
      @close="close()"
    >
      <el-image
        style="width: 100%"
        :src="imgUrl"
        fit="contain"
        @click="onClick()"
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      changVisible: false,

      imgUrl: "",
    };
  },
  mounted() {},
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    onClick() {
      this.close();
    },
    //页面初始化时加载的事件
    show(imgUrl) {
      this.imgUrl = imgUrl;
      this.changVisible = true;
    },
  },
};
</script>

<style lang="less">
// .el-dialog__header {
//   padding: 0px;
// }
// .el-dialog--center .el-dialog__body {
//   /* text-align: initial; */
//   padding: 0px;
// }
// .el-dialog {
//   position: relative;
//   // margin: 0 auto 50px;
//   border-radius: 2px;
//   -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   // width: 0px;
// }
</style>



// WEBPACK FOOTER //
// src/components/dialog/imageDialog.vue